import { createBrowserRouter } from "react-router-dom";

import App from './App';
import FacilityData from "./components/FacilityData";
import Landing from "./components/Landing";
import LoadMonitoring from "./components/LoadMonitoring";
import MarketAnalysis from './components/MarketAnalysis';
import MarketOperations from './components/MarketOperation';
import NewSubmission from "./components/NewSubmissions";
import PageNotFound from "./components/PageNotFound";
import FacilityParticipation from "./components/FacilityParticipation";
import BESS_Strategy from "./components/BESS_Strategy";
import SignOut from "./components/SignOut";
// import FacilityLoad from "./components/loadmonitoring/FacilityLoad";

export const publicRoutes = [
  {
    path: "/",
    element: <Landing />,
  },
];

export const protectedRoutes = [
  {
    path: "/market-analysis/",
    element: <MarketAnalysis />,
  },
  // {
  //   path: "/market-operations",
  //   element: <MarketOperations />,
  // },
  {
    path: "/load-monitoring/",
    element: <LoadMonitoring />,
  },
  // TODO: un-comment routes upon development completion
  // {
  //   path: "/facility-data",
  //   element: <FacilityData />,
  // },
  // {
  //   path: "/new-submission",
  //   element: <NewSubmission />,
  // },
  // {
  //   path: "/facility-participation",
  //   element: <FacilityParticipation />,
  // },
  {
    path: "/bess-strategy/",
    element: <BESS_Strategy />,
  },
  {
    path: "/sign-out", // Add this route
    element: <SignOut />,
  },

];

const router = createBrowserRouter([
  {
    element: <App />,
    errorElement: <PageNotFound />,
    children: [...publicRoutes, ...protectedRoutes],
  },
]);

export default router;